import React from "react";

// Google's required disclosure for pages where the reCAPTCHA badge is not
// visible (ours loads lazily on first submission, so the badge appears too
// late to satisfy the branding terms on its own).
export const RecaptchaDisclosure = () => (
  <p style={{ fontSize: 11, color: "#888", margin: "10px 0 0", textAlign: "center", lineHeight: 1.5 }}>
    This site is protected by reCAPTCHA and the Google{" "}
    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={{ color: "#888" }}>
      Privacy Policy
    </a>{" "}
    and{" "}
    <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" style={{ color: "#888" }}>
      Terms of Service
    </a>{" "}
    apply.
  </p>
);
